export const MAX_TRANSFER_ARTWORKS = 10;
